var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionOverrepotingOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c5.523 0 10 4.477 10 10a9.98 9.98 0 01-.567 3.324l-1.7-1.275c.09-.341.157-.692.203-1.049H18v-2h1.936a7.956 7.956 0 00-1.618-3.904L16.95 9.465 15.535 8.05l1.368-1.37A7.957 7.957 0 0013 5.064V7h-2V5.063a7.958 7.958 0 00-3.904 1.618L8.465 8.05 7.05 9.465l-1.37-1.37A7.957 7.957 0 004.065 12H6v2H4.063a7.979 7.979 0 002.65 5H15l2.666 2H5.999A9.985 9.985 0 012 13C2 7.477 6.477 3 12 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11a2 2 0 011.983 2.238L20.6 18.2l-1.2 1.6-6.615-4.961A2 2 0 1112 11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionOverrepotingOutline);
export default __webpack_public_path__ + "6bcf4ba0b060a491a37acc1b8d401d19.svg";
export { ForwardRef as ReactComponent };